import React from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  IconographyThemes,
  Loader,
  LoaderSizes,
} from "@hid-galaxy-ui/galaxy-react";
import "./ErrorPopup.scss"; 

type Props = {
  open: boolean;
  message: string;
  onClose: () => void;
  type?: "success" | "error"; // success | error types
  loading?: boolean; // 🔹 NEW
};

const ErrorPopup: React.FC<Props> = ({
  open,
  message,
  onClose,
  type = "error", // default to 'error'
  loading = false, // default to false
}) => {
  if (!open) return null;

  return (
    <div className="error-status-page">
      <div className="error-status-container">
        {/* Header Section with Close Icon */}
        <div className="error-popup-header">
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <Iconography icon="xmark" size={IconographySizes.Small} />
          </button>
        </div>
        {loading ? (
          <Loader variant={LoaderSizes.large} /> // Show loader if loading
        ) : type === "error" ? (
          <>
            <Iconography
              icon="circleXmark"
              size={IconographySizes.XLarge}
              theme={IconographyThemes.Error}
            />
            <div className="message">{message}</div>
          </>
        ) : (
          <>
            <Iconography
              icon="circleCheck"
              size={IconographySizes.XLarge}
              theme={IconographyThemes.Success}
            />
            <div className="message">{message}</div>
          </>
        )}

        {!loading && (
          <footer className="error-status__footer">
            <Button
              variant="contained"
              color={type === "success" ? "success" : "primary"}
              label="Close"
              onClick={onClose}
            />
          </footer>
        )}
      </div>
    </div>
  );
};

export default ErrorPopup;
